import React from "react";
import { IErrorMessageProps } from "./interfaces/IErroMessageProps";
import { Typography } from "@mui/material";

export const ErrorMessage: React.FC<IErrorMessageProps> = (props) => {
  const { value } = props;

  return (
    <Typography variant="body2" color="error" sx={{ fontSize: "0.8rem", p: 1 }}>
      {value}
    </Typography>
  );
};
